<template>
	<div class="mainPage">
		<div class="header_banner">
			<header>
				<div class="center">
					<div class="right">
						
						<div v-if="!isLogin" class="loginCon">
							<span @click="toLogin()">{{ $t('message.login') }}</span> /
							<span @click="toLogin()">{{ $t('message.register') }}</span>
						</div>
						<div v-if="isLogin" class="loginCon">
							<span><span class="username">{{ user.username }}</span><span @click="toLogOut()">{{
								$t('message.logout') }}</span> </span>
						</div>
					</div>
				</div>
			</header>
			<div class="infoCon">
				<div class="centerBg">
					<img src="../img/chineseCultureVideoExhibition/logo2.png" alt="" class="left">
				</div>
			</div>
		</div>
		<div class="content">
			<div class="leftBox">
				<div class="box">
					<div class="titleBox" v-for="(item, index) in subject_info" :key="item.id" :class="{ active: active === index }"
						@click="goAnchor('t' + item.id)">
						<div class="title" v-if="item.courseList && item.courseList[0] && item.template == 1" >
							<span class="title_cn">{{ item.name }}</span>
							<span class="title_en">{{ item.name_en }}</span>
						</div>

						<img src="../img/chineseCultureVideoExhibition/icon1.png" alt="" class="icon" v-if="item.courseList && item.courseList[0] && item.template == 1">
					</div>
				</div>
			</div>

			<div class="rightBox">

				<div class="projectProfile">
					<div class="kuang1">
						<img src="../img/chineseCultureVideoExhibition/kuang.png" alt="">
					</div>
					<div class="box">
						<div class="text">为了让海外中文学习爱好者感受中外文化的交相辉映和世界文明的多姿多彩,我们将邀您共赏《经典咏流传——正青春》《美术里的中国》《我的汉字故事》《沙海之上》等中央广播电视总台制作的精品节目，后续还将推出《新丝路上的交响》“一带一路”主题节目，为海外中华文化爱好者、中国语言学习者带来精彩纷呈、美美与共的视听盛宴。</div>
						<div class="text2">To offer Chinese language learners abroad an authentic experience of the fusion of Chinese	and foreign cultures, as well as the richness of global civilization, we extend a warm invitation for you to delve into the captivating programs presented by CMG. These remarkable series include "Everlasting Classics - Youth in Full Bloom," "Fine Arts in China," "My Stories of Chinese Characters," and "Above Desert and Sea." Additionally, we will launch the themed program "The Call of the Silk Road," inextricably linked to the "Belt and Road Initiative." These programs promise an extraordinary visual and	auditory journey for Chinese culture enthusiasts and those dedicated to learning the language.</div>
					</div>

				</div>

				<div class="classBox" v-for="(subject) in subject_info" :key="subject.id" :ref="subject.id" >
					<div class="classBox1" v-if="subject.courseList && subject.courseList[0] && subject.template == 1" :id="'t' + subject.id">

						<img :src="subject.extra.schoolLogo" alt="" class="title" >
						<div class="text_cn" v-if="subject.courseList && subject.courseList[0] && subject.courseList[0].describe">{{
							subject.courseList[0].describe }}</div>
						<div class="text_en" v-if="subject.courseList && subject.courseList[0] && subject.courseList[0].describe_en">
							{{ subject.courseList[0].describe_en }}
						</div>
						<div class="swiper_con">
							<swiper :options="swiperOption" ref="mySwiper" class="swiper">

								<swiper-slide v-for="(v, index) in subject.courseList" :key="index" style="width: 3.5rem;">
									<div class="video_con" :data-info="v.name" @click="replay(v.video_url, v.cover_url)">
										<div class="video_cover">
											<img :src="v.cover_url" :alt="v.video_url" class="cover">
										</div>
										<div class="titleBox">
											<div class="course_title">
												<div class="cn">{{ v.name }}</div>
												<div class="en">{{ v.name_en }}</div>
											</div>
										</div>
									</div>
								</swiper-slide>
								<div class="swiper-button-prev" slot="button-prev"></div>
								<div class="swiper-button-next" slot="button-next"></div>
							</swiper>

						</div>
					</div>


				</div>
			</div>


		</div>

		<div class="footer">
			<div class="copy">Copyright © ChinesePlus</div>
			<div class="bottomBg">

			</div>
			<img src="../img/chineseCultureVideoExhibition/footer.png" alt="">
		</div>

		<transition name="fade">
			<div id="videoPlayWrapper" v-if="isPlay" @mousewheel.prevent>
				<div class="videoContent">
					<div class="closeVideo" @click="closeVideo()">×</div>
					<div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" autoplay controls 
							controlsList="nodownload"></video></div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import Qs from 'qs'
import language from './common/language'
export default {
	name: 'chinesebridge',
	components: {
		language
	},
	metaInfo() {
		return {
			title: '中央广播电视总台精品节目“一带一路”共建国家展播',
			meta: [
				{
					name: 'keyword',
					content: '中文联盟精品课程,精品内容展播,一带一路展播，中央广播电视总台精品节目“一带一路”共建国家展播'
				},
				{
					name: 'description',
					content: '中文联盟汉语文化线上培训平台精品课程,中央广播电视总台精品节目“一带一路”共建国家展播'
				},
			]
		}
	},
	data: function () {
		return {
			isChrome: true,
			isLogin: false,
			isPlay: false,
			currentVideoUrl: '',
			imgUrl: '',
			user: {
				username: '',
				email: ''
			},
			lang: 'cn',
			isShowGuide: true,
			subjectName: [
				'chinese_Culture_Video_Exhibition1',
				'chinese_Culture_Video_Exhibition2',
				'chinese_Culture_Video_Exhibition3',
				'chinese_Culture_Video_Exhibition4',
				'chinese_Culture_Video_Exhibition5',
				'chinese_Culture_Video_Exhibition6',
				'chinese_Culture_Video_Exhibition7',
				'chinese_Culture_Video_Exhibition8',
				'chinese_Culture_Video_Exhibition9',
				'chinese_Culture_Video_Exhibition10',
				'chinese_Culture_Video_Exhibition11',
				'chinese_Culture_Video_Exhibition12',
			],
			subjectName_en: [
				{
					name: '',
					name_en: 'CLASSIC CHANTING AND SPREADING - POSITIVE YOUTH'
				}
			],
			active: 0,
			subject_info: [],
			courseList: {},
			activeTab: 0,
			subject_id: null,
			subject_name: [],
			subject_subText: [],

			swiperOption: {
				// loop: true,
				// autoplay: true,
				spaceBetween: 20,
				speed: 500,
				slidesPerView: 'auto',
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				pagination: {
					el: '.swiper-pagination'
				},
			},

		}
	},
	computed: {
		language() {
			return this.$i18n.locale
		}
	},
	methods: {

		// tolive(url) {
		// 	window.open(url)
		// },
		// 登录
		toLogin() {
			window.location.href =
				this.baseUrl +
				"user/api/login?" +
				"callback=" +
				encodeURIComponent(window.location.href);
		},
		// 注册
		toRegister() {
			window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
		},
		// 检查是否登录 获取用户信息
		customCheckLogin() {
			this.checkLogin().then(res => {
				if (res.data.success) {
					this.isLogin = true
					this.user = res.data.data
				} else {
					this.isLogin = false
				}
			}).catch((r) => {
				console.log(r)
			})
		},
		// 退出登录
		toLogOut() {
			this.$utils.get('/user/api/logout').then(res => {
				if (res.data.success) {
					this.isLogin = false
				}
			})
		},


		//获取后端专题数据
		async getAllInfo() {

			// 循环获取专题信息
			this.subjectName.forEach((item) => {
				//获取专题数据
				this.getSubjectInfo(item);
				//将标题图片信息添加到数组中
				// console.log('专题信息', this.subject_info)
			})

		},

		// 获取专题信息
		async getSubjectInfo(alias) {
			await this.$utils.get('/subject/subject/readbyalias', {
				alias
			}).then(res => {
				if (res.data.success) {
					
					//获取课程数据
					if (res.data.data.template == 1){
						this.subject_info.push(res.data.data)
						this.getCourseInfo(res.data.data.id)
					}
				}
			}).catch((r) => {
				console.log(r)
			})
		},

		// 通过专题ID信息 获取课程列表
		async getCourseInfo(id) {
			await this.$utils.get('/subject/lesson/getlist', {
				subject_id: id,
				limit: 200
			}).then(res => { //处理课程列表
				if (res.data.success) {
					this.courseList = res.data.data.list
					this.subject_info.forEach((item, index) => {
						if (item.id == id ) {
							this.$set(this.subject_info[index], "courseList", res.data.data.list)
							this.$forceUpdate()

							// console.log('121212', this.subject_info[index])
						}
					})
				}
				// console.log('课程数据', this.subject_info) //所有课程
				//排序
				this.subject_info.sort(this.compare('id'))
				// this.$forceUpdate()

			}).catch((r) => {
				console.log(r)
			})
		},

		//排序
		compare(property) {
			return function (a, b) {
				var value1 = a[property];
				var value2 = b[property];
				return value1 - value2;
			}
		},

		// 滚动监听器
		onScroll() {
			// 获取所有锚点元素
			const navContents = document.querySelectorAll('.classBox1')
			// console.log(navContents)

			// 所有锚点元素的 offsetTop
			const offsetTopArr = []
			navContents.forEach(item => {
				offsetTopArr.push(item.offsetTop)
			})
			// 获取当前文档流的 scrollTop
			const scrollTop = document.documentElement.scrollTop
			const clientHeight = document.documentElement.clientHeight
			const scrollHeight = document.documentElement.scrollHeight
			// console.log('top', scrollTop, offsetTopArr)
			// 定义当前点亮的导航下标
			let navIndex = 0
			for (let n = 0; n < offsetTopArr.length; n++) {
				// 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
				// 那么此时导航索引就应该是n了
				// console.log('clientHeight', offsetTopArr[n] , navContents[n].clientHeight )
				if (scrollTop >= offsetTopArr[n] - navContents[n].clientHeight) {
					// console.log('clientHeight',navContents[n].clientHeight)
					navIndex = n
				}
			}
			if(scrollTop + clientHeight == scrollHeight){
				navIndex = offsetTopArr.length -1
			}
			this.active = navIndex
		},

		goAnchor(selector) {
			// console.log('#'+ selector)
			this.$el.querySelector('#' + selector ).scrollIntoView({
				behavior: "smooth", // 平滑过渡
				block: "start", // 上边框与视窗顶部平齐。默认值
			});
		},

		//播放课程
		replay(url, cover) {
			// console.log(url)
			this.currentVideoUrl = url
			this.imgUrl = cover
			this.isPlay = true
			setTimeout(function () { // 
				$('#liveVideo').bind('contextmenu', function () { return false; }) //为video添加禁止右键另存为操作 
			}, 50)
		},
		closeVideo() {
			var myvideo = document.getElementById("liveVideo");
			if (!myvideo.paused) { //视频正在播放中时停止播放
				myvideo.pause();
			}
			this.isPlay = false
		},
		checkChrome() {
			var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
			if (!isChrome) {
				this.isChrome = false
			}
		}
	},


	created() {
		// 专题获取数据
		this.getAllInfo()

	},
	mounted() {

		this.customCheckLogin()
		// this.getAllInfo()
		this.checkChrome()
		// 监听滚动事件
		window.addEventListener('scroll', this.onScroll, false)

		let activeTab = this.$route.query.tab
		if (activeTab) {
			this.activeTab = activeTab
		}

	},
	destroy() {
		// 移除监听器
		window.removeEventListener('scroll', this.onScroll)
	},


}
</script>


<style scoped lang="scss">
.mainPage {
	width: 100%;
	text-align: center;
	position: relative;
	min-height: 100%;
	background-color: #ebf0f9;
	background: linear-gradient(to right, #def3fd61, #ffdae23d);
	user-select: none;


	.agentTip {
		width: 100%;
		height: 70px;
		line-height: 70px;
		background-color: #ffe6a1;
		text-align: center;
		position: absolute;
		z-index: 5;
		color: #c40000;
	}

	.agentTip .closeTip {
		position: absolute;
		right: 24px;
		top: 0px;
		font-size: 30px;
		color: #282828;
		cursor: pointer;
	}

	.header_banner {
		position: relative;
		background-image: url(../img/chineseCultureVideoExhibition/banner3.png);
		height: 540px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;

		header {
			position: absolute;
			height: 50px;
			line-height: 50px;
			z-index: 2;
			// border-bottom: 1px solid rgba(#fff, 0.3);
			top: 0;
			width: 100%;
			margin: auto;
			color: #fff;

			.center {
				color: #8590cc;
				width: 1200px;
				margin: auto;

				a {
					color: #8590cc;
					margin-right: 15px;
					// opacity: 0.8;
				}
			}

			.left {
				float: left;
			}

			.right {
				line-height: 50px;
				float: right;

				img {
					vertical-align: text-top;
					margin-right: 15px;
				}

				.loginCon {
					display: inline-block;
					margin-left: 30px;

					span {
						cursor: pointer;
					}

					.username {
						margin-right: 12px;
					}
				}
			}
		}

		.infoCon {

			.centerBg {
				width: 1200px;
				margin: auto;
				position: absolute;
				top: 25px;
				left: 280px;
				right: 0;

				.left {
					float: left;
					margin-top: 20px;
				}

				.right {
					float: right;
				}
			}
		}
	}

	.content {
		display: flex;
		flex-direction: row;
		justify-content: center;
		max-width: 1400px;
		// height: 2860px;
		margin: auto;
		margin-top: -125px;



		.leftBox {
			width: 20%;
			height: fit-content;
			margin-left: -105px;
			text-align: end;
			border-right: 1px solid rgb(138, 138, 138);
			position: sticky;
			top: 80px;

			.box {
				display: flex;
				flex-direction: column;
				margin-right: -16px;
				margin-top: 15px;
				margin-bottom: 15px;

				.titleBox {
					
					display: flex;
					justify-content: flex-end;
					align-items: center;
					cursor: pointer;

					.title {
						padding: 7px 10px;
						display: flex;
						flex-direction: column;
						margin-right: 45px;

						.title_cn {
							font-size: 18px;
							line-height: 30px;
						}

						.title_en {
							font-size: 12px;
							font-family: DINCond-Medium;
						}

					}

					.icon {
						width: 30px;
						height: 30px;
						display: none;
					}
				}

				.titleBox.active {
					.title {
						color: darkorange;
						margin-right: 15px;
					}

					.icon {
						display: block;
					}
				}


			}
		}



		.rightBox {
			width: 80%;
			display: flex;
			flex-direction: column;
			text-align: left;
			margin-left: 110px;

			.projectProfile {

				// width: 100%;
				// background-image: url(../img/chineseCultureVideoExhibition/kuang.png);
				.kuang1 {
					position: absolute;
					margin-top: 10px;
					z-index: 100;
				}

				.box {
					width: 95%;
					height: 250px;
					border-radius: 10px;
					background-color: #fdfbfb;
					opacity: 0.7;
					z-index: 10;
					margin: auto;
					margin-top: 10px;
					margin-bottom: 40px;

					.text {
						font-size: 16px;
						color: #282828;
						padding-top: 25px;
						padding-left: 35px;
						padding-right: 55px;
						margin-top: 35px;
						line-height: 26px;
						text-align: justify;
						text-indent: 2em;
					}

					.text2 {
						font-size: 15px;
						color: #282828;
						padding-left: 35px;
						padding-right: 55px;
						line-height: 24px;
						text-align: justify;
						// text-indent:2em;
					}
				}
			}


			.classBox {

				.title {}

				.text_cn {
					font-size: 16px;
					color: #5e696d;
					line-height: 24px;
					margin-top: 20px;
					margin-bottom: 5px;
				}

				.text_en {
					font-size: 14px;
					color: #5e696d;
					line-height: 20px;
					// margin-bottom: 20px;
				}

				.swiper_con {
					margin-top: 25px;
					margin-left: 0rem;
					margin-bottom: 40px;
					position: relative;

					.swiper-container {
						position: unset;
					}

					.swiper {
						.swiper-slide {
							width: 3.6rem !important;

							.swiperBox {
								overflow: hidden;
							}
						}

						.video_con {
							width: 3.6rem;

							.huan_icon {
								display: block;
								// position: absolute;
								width: .78rem;
								bottom: 0;
								margin-top: -2rem;
								margin: auto;
								margin-top: -2rem;
								position: relative;
								z-index: 3;
							}

							.video_name_con {
								width: 4.8rem;
								height: 1.1rem;
								line-height: 1.2rem;
								font-weight: bold;
								background-color: #04c7de;
								border-radius: .2rem;
								border: solid .04rem #000000;
								font-family: HYJiJinTiW;
								text-align: center;
								font-size: .3rem;
								color: #ffffff;
								margin: auto;
								position: relative;
								z-index: 2;
								margin-top: -.4rem;
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
								-o-text-overflow: ellipsis;
								padding: 0 .2rem;
								box-sizing: border-box;
							}

							.video_cover {
								width: 3.6rem;
								height: calc(3.4rem/ (16/9));
								background-color: #ffae00;
								// border-radius: .2rem;
								// border: solid .04rem #000000;
								// overflow: hidden;
								// margin-top: -.4rem;

								img {
									display: block;
									width: 100%;
									height: 100%;
									cursor: pointer;
								}

							}

							.titleBox {
								position: absolute;
								height: 55px;
								margin-top: -55px;
								width: 100%;
								color: #fff;
								background-color: #55565775;
								text-align: left;
								z-index: 100;
								display: flex;
    						align-items: center;

								.course_title {
									padding: 10px 20px;

									.cn {
										font-size: 16px;
									}

									.en {
										margin-top: 4px;
										font-size: 14px;
									}
								}
							}
						}
					}

					.swiper-button-prev {
						background-image: url(../img/chineseCultureVideoExhibition/prev.png);
						position: absolute;
						left: -75px;
						top: 90px;
					}

					.swiper-button-next {
						background-image: url(../img/chineseCultureVideoExhibition/next.png);
						right: -75px;
						top: 90px;
					}


				}

			}
		}
	}

	.footer {
		margin-top: -340px;

		.copy {
			position: absolute;
			bottom: 140px;
			width: 100%;
			text-align: center;
			font-weight: 600;
		}

		img {
			width: 100%;
		}
	}



	#videoPlayWrapper {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.8);
		z-index: 999;
	}

	#videoPlayWrapper .closeVideo {
		position: absolute;
		right: 20px;
		top: 10px;
		font-size: 50px;
		color: #fff;
		cursor: pointer;
	}

	.videoContent {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.videoContainer {
		text-align: center;
		width: 100%;
	}

	.videoContainer video {
		width: 62%;
	}

	video::-internal-media-controls-download-button {
		display: none;
	}

	video::-webkit-media-controls-enclosure {
		overflow: hidden;
	}

	video::-webkit-media-controls-panel {
		width: calc(100% + 30px);
	}
}

// 110%
@media screen and (max-width: 1750px) {


	.mainPage .header_banner {
		height: 560px;
	}

	.mainPage .content .rightBox .classBox .swiper_con {

		.swiper {
			.swiper-slide {
				width: 4rem !important;

				.video_con {
					width: 4rem;

					.video_cover {
						width: 4rem;
						height: calc(4rem/ (16/9));
					}
				}
			}
		}

		.swiper-button-next[data-v-5f9973b2] {
			right: -60px;
		}

	}

	.mainPage .footer{
		margin-top: -360px;
		.copy {
			bottom: 100px;
		}
	} 


}

// 125%
@media screen and (max-width: 1540px) {

	.mainPage .header_banner {
		height: 540px;
	}

	.mainPage .content .rightBox .classBox .swiper_con {

		.swiper {
			.swiper-slide {
				width: 4.5rem !important;

				.video_con {
					width: 4.5rem;

					.video_cover {
						width: 4.5rem;
						height: calc(4.3rem/ (16/9));
					}
				}
			}
		}

		.swiper-button-next[data-v-5f9973b2] {
			right: -60px;
		}

	}

	.mainPage .footer {
		margin-top: -400px;
	}



}

// 150%
@media screen and (max-width: 1280px) {

	.mainPage .header_banner {
		height: 410px;
	}

	.mainPage .content .rightBox .classBox .swiper_con {

		.swiper {
			.swiper-slide {
				width: 5rem !important;

				.video_con {
					width: 5rem;

					.video_cover {
						width: 5rem;
						height: calc(4.7rem/ (16/9));
					}
				}
			}
		}

		.swiper-button-next[data-v-5f9973b2] {
			right: -60px;
		}

	}

	.mainPage .header_banner .infoCon .centerBg {
		transform: scale(0.7);
		top:-20px;
		left: 130px;
	}

	.projectProfile {
		transform: scale(0.9);
		margin-left: -100px;
	}

	.mainPage .content {
		.leftBox {
			transform: scale(0.9);
			left: -50px;
			top: 0;
		}

		.rightBox {
			transform: scale(0.9);
			margin-top: -140px;
			margin-left: 70px;

		}

		// height: 3000px;
		// transform: scale(0.8);
	}
}</style>
